const validate = (values, { t }) => {
  const errors = {};
  if (!values.name) {
    errors.name = t('validations.required');
  }
  return errors;
};

export default validate;
